import { JSONSchema7 } from 'json-schema';

export const ISO_3166_COUNTRY_CODES = [
  { const: 'US', title: 'United States of America' },
  { const: 'CA', title: 'Canada' },
  { const: 'MX', title: 'Mexico' },
  { const: 'AD', title: 'Andorra' },
  { const: 'AE', title: 'United Arab Emirates' },
  { const: 'AF', title: 'Afghanistan' },
  { const: 'AG', title: 'Antigua and Barbuda' },
  { const: 'AI', title: 'Anguilla' },
  { const: 'AL', title: 'Albania' },
  { const: 'AM', title: 'Armenia' },
  { const: 'AO', title: 'Angola' },
  { const: 'AQ', title: 'Antarctica' },
  { const: 'AR', title: 'Argentina' },
  { const: 'AS', title: 'American Samoa' },
  { const: 'AT', title: 'Austria' },
  { const: 'AU', title: 'Australia' },
  { const: 'AW', title: 'Aruba' },
  { const: 'AX', title: 'Åland Islands' },
  { const: 'AZ', title: 'Azerbaijan' },
  { const: 'BA', title: 'Bosnia and Herzegovina' },
  { const: 'BB', title: 'Barbados' },
  { const: 'BD', title: 'Bangladesh' },
  { const: 'BE', title: 'Belgium' },
  { const: 'BF', title: 'Burkina Faso' },
  { const: 'BG', title: 'Bulgaria' },
  { const: 'BH', title: 'Bahrain' },
  { const: 'BI', title: 'Burundi' },
  { const: 'BJ', title: 'Benin' },
  { const: 'BL', title: 'Saint Barthélemy' },
  { const: 'BM', title: 'Bermuda' },
  { const: 'BN', title: 'Brunei Darussalam' },
  { const: 'BO', title: 'Bolivia (Plurinational State of)' },
  { const: 'BQ', title: 'Bonaire, Sint Eustatius and Saba' },
  { const: 'BR', title: 'Brazil' },
  { const: 'BS', title: 'Bahamas' },
  { const: 'BT', title: 'Bhutan' },
  { const: 'BV', title: 'Bouvet Island' },
  { const: 'BW', title: 'Botswana' },
  { const: 'BY', title: 'Belarus' },
  { const: 'BZ', title: 'Belize' },
  { const: 'CC', title: 'Cocos (Keeling) Islands' },
  { const: 'CD', title: 'Congo, Democratic Republic of the' },
  { const: 'CF', title: 'Central African Republic' },
  { const: 'CG', title: 'Congo' },
  { const: 'CH', title: 'Switzerland' },
  { const: 'CI', title: "Côte d'Ivoire" },
  { const: 'CK', title: 'Cook Islands' },
  { const: 'CL', title: 'Chile' },
  { const: 'CM', title: 'Cameroon' },
  { const: 'CN', title: 'China' },
  { const: 'CO', title: 'Colombia' },
  { const: 'CR', title: 'Costa Rica' },
  { const: 'CU', title: 'Cuba' },
  { const: 'CV', title: 'Cabo Verde' },
  { const: 'CW', title: 'Curaçao' },
  { const: 'CX', title: 'Christmas Island' },
  { const: 'CY', title: 'Cyprus' },
  { const: 'CZ', title: 'Czechia' },
  { const: 'DE', title: 'Germany' },
  { const: 'DJ', title: 'Djibouti' },
  { const: 'DK', title: 'Denmark' },
  { const: 'DM', title: 'Dominica' },
  { const: 'DO', title: 'Dominican Republic' },
  { const: 'DZ', title: 'Algeria' },
  { const: 'EC', title: 'Ecuador' },
  { const: 'EE', title: 'Estonia' },
  { const: 'EG', title: 'Egypt' },
  { const: 'EH', title: 'Western Sahara' },
  { const: 'ER', title: 'Eritrea' },
  { const: 'ES', title: 'Spain' },
  { const: 'ET', title: 'Ethiopia' },
  { const: 'FI', title: 'Finland' },
  { const: 'FJ', title: 'Fiji' },
  { const: 'FK', title: 'Falkland Islands (Malvinas)' },
  { const: 'FM', title: 'Micronesia (Federated States of)' },
  { const: 'FO', title: 'Faroe Islands' },
  { const: 'FR', title: 'France' },
  { const: 'GA', title: 'Gabon' },
  { const: 'GB', title: 'United Kingdom of Great Britain and Northern Ireland' },
  { const: 'GD', title: 'Grenada' },
  { const: 'GE', title: 'Georgia' },
  { const: 'GF', title: 'French Guiana' },
  { const: 'GG', title: 'Guernsey' },
  { const: 'GH', title: 'Ghana' },
  { const: 'GI', title: 'Gibraltar' },
  { const: 'GL', title: 'Greenland' },
  { const: 'GM', title: 'Gambia' },
  { const: 'GN', title: 'Guinea' },
  { const: 'GP', title: 'Guadeloupe' },
  { const: 'GQ', title: 'Equatorial Guinea' },
  { const: 'GR', title: 'Greece' },
  { const: 'GS', title: 'South Georgia and the South Sandwich Islands' },
  { const: 'GT', title: 'Guatemala' },
  { const: 'GU', title: 'Guam' },
  { const: 'GW', title: 'Guinea-Bissau' },
  { const: 'GY', title: 'Guyana' },
  { const: 'HK', title: 'Hong Kong' },
  { const: 'HM', title: 'Heard Island and McDonald Islands' },
  { const: 'HN', title: 'Honduras' },
  { const: 'HR', title: 'Croatia' },
  { const: 'HT', title: 'Haiti' },
  { const: 'HU', title: 'Hungary' },
  { const: 'ID', title: 'Indonesia' },
  { const: 'IE', title: 'Ireland' },
  { const: 'IL', title: 'Israel' },
  { const: 'IM', title: 'Isle of Man' },
  { const: 'IN', title: 'India' },
  { const: 'IO', title: 'British Indian Ocean Territory' },
  { const: 'IQ', title: 'Iraq' },
  { const: 'IR', title: 'Iran (Islamic Republic of)' },
  { const: 'IS', title: 'Iceland' },
  { const: 'IT', title: 'Italy' },
  { const: 'JE', title: 'Jersey' },
  { const: 'JM', title: 'Jamaica' },
  { const: 'JO', title: 'Jordan' },
  { const: 'JP', title: 'Japan' },
  { const: 'KE', title: 'Kenya' },
  { const: 'KG', title: 'Kyrgyzstan' },
  { const: 'KH', title: 'Cambodia' },
  { const: 'KI', title: 'Kiribati' },
  { const: 'KM', title: 'Comoros' },
  { const: 'KN', title: 'Saint Kitts and Nevis' },
  { const: 'KP', title: "Korea (Democratic People's Republic of)" },
  { const: 'KR', title: 'Korea, Republic of' },
  { const: 'KW', title: 'Kuwait' },
  { const: 'KY', title: 'Cayman Islands' },
  { const: 'KZ', title: 'Kazakhstan' },
  { const: 'LA', title: "Lao People's Democratic Republic" },
  { const: 'LB', title: 'Lebanon' },
  { const: 'LC', title: 'Saint Lucia' },
  { const: 'LI', title: 'Liechtenstein' },
  { const: 'LK', title: 'Sri Lanka' },
  { const: 'LR', title: 'Liberia' },
  { const: 'LS', title: 'Lesotho' },
  { const: 'LT', title: 'Lithuania' },
  { const: 'LU', title: 'Luxembourg' },
  { const: 'LV', title: 'Latvia' },
  { const: 'LY', title: 'Libya' },
  { const: 'MA', title: 'Morocco' },
  { const: 'MC', title: 'Monaco' },
  { const: 'MD', title: 'Moldova, Republic of' },
  { const: 'ME', title: 'Montenegro' },
  { const: 'MF', title: 'Saint Martin (French part)' },
  { const: 'MG', title: 'Madagascar' },
  { const: 'MH', title: 'Marshall Islands' },
  { const: 'MK', title: 'North Macedonia' },
  { const: 'ML', title: 'Mali' },
  { const: 'MM', title: 'Myanmar' },
  { const: 'MN', title: 'Mongolia' },
  { const: 'MO', title: 'Macao' },
  { const: 'MP', title: 'Northern Mariana Islands' },
  { const: 'MQ', title: 'Martinique' },
  { const: 'MR', title: 'Mauritania' },
  { const: 'MS', title: 'Montserrat' },
  { const: 'MT', title: 'Malta' },
  { const: 'MU', title: 'Mauritius' },
  { const: 'MV', title: 'Maldives' },
  { const: 'MW', title: 'Malawi' },
  { const: 'MY', title: 'Malaysia' },
  { const: 'MZ', title: 'Mozambique' },
  { const: 'NA', title: 'Namibia' },
  { const: 'NC', title: 'New Caledonia' },
  { const: 'NE', title: 'Niger' },
  { const: 'NF', title: 'Norfolk Island' },
  { const: 'NG', title: 'Nigeria' },
  { const: 'NI', title: 'Nicaragua' },
  { const: 'NL', title: 'Netherlands' },
  { const: 'NO', title: 'Norway' },
  { const: 'NP', title: 'Nepal' },
  { const: 'NR', title: 'Nauru' },
  { const: 'NU', title: 'Niue' },
  { const: 'NZ', title: 'New Zealand' },
  { const: 'OM', title: 'Oman' },
  { const: 'PA', title: 'Panama' },
  { const: 'PE', title: 'Peru' },
  { const: 'PF', title: 'French Polynesia' },
  { const: 'PG', title: 'Papua New Guinea' },
  { const: 'PH', title: 'Philippines' },
  { const: 'PK', title: 'Pakistan' },
  { const: 'PL', title: 'Poland' },
  { const: 'PM', title: 'Saint Pierre and Miquelon' },
  { const: 'PN', title: 'Pitcairn' },
  { const: 'PR', title: 'Puerto Rico' },
  { const: 'PS', title: 'Palestine, State of' },
  { const: 'PT', title: 'Portugal' },
  { const: 'PW', title: 'Palau' },
  { const: 'PY', title: 'Paraguay' },
  { const: 'QA', title: 'Qatar' },
  { const: 'RE', title: 'Réunion' },
  { const: 'RO', title: 'Romania' },
  { const: 'RS', title: 'Serbia' },
  { const: 'RU', title: 'Russian Federation' },
  { const: 'RW', title: 'Rwanda' },
  { const: 'SA', title: 'Saudi Arabia' },
  { const: 'SB', title: 'Solomon Islands' },
  { const: 'SC', title: 'Seychelles' },
  { const: 'SD', title: 'Sudan' },
  { const: 'SE', title: 'Sweden' },
  { const: 'SG', title: 'Singapore' },
  { const: 'SH', title: 'Saint Helena, Ascension and Tristan da Cunha' },
  { const: 'SI', title: 'Slovenia' },
  { const: 'SJ', title: 'Svalbard and Jan Mayen' },
  { const: 'SK', title: 'Slovakia' },
  { const: 'SL', title: 'Sierra Leone' },
  { const: 'SM', title: 'San Marino' },
  { const: 'SN', title: 'Senegal' },
  { const: 'SO', title: 'Somalia' },
  { const: 'SR', title: 'Suriname' },
  { const: 'SS', title: 'South Sudan' },
  { const: 'ST', title: 'Sao Tome and Principe' },
  { const: 'SV', title: 'El Salvador' },
  { const: 'SX', title: 'Sint Maarten (Dutch part)' },
  { const: 'SY', title: 'Syrian Arab Republic' },
  { const: 'SZ', title: 'Eswatini' },
  { const: 'TC', title: 'Turks and Caicos Islands' },
  { const: 'TD', title: 'Chad' },
  { const: 'TF', title: 'French Southern Territories' },
  { const: 'TG', title: 'Togo' },
  { const: 'TH', title: 'Thailand' },
  { const: 'TJ', title: 'Tajikistan' },
  { const: 'TK', title: 'Tokelau' },
  { const: 'TL', title: 'Timor-Leste' },
  { const: 'TM', title: 'Turkmenistan' },
  { const: 'TN', title: 'Tunisia' },
  { const: 'TO', title: 'Tonga' },
  { const: 'TR', title: 'Türkiye' },
  { const: 'TT', title: 'Trinidad and Tobago' },
  { const: 'TV', title: 'Tuvalu' },
  { const: 'TW', title: 'Taiwan, Province of China[note 2]' },
  { const: 'TZ', title: 'Tanzania, United Republic of' },
  { const: 'UA', title: 'Ukraine' },
  { const: 'UG', title: 'Uganda' },
  { const: 'UM', title: 'United States Minor Outlying Islands' },
  { const: 'UY', title: 'Uruguay' },
  { const: 'UZ', title: 'Uzbekistan' },
  { const: 'VA', title: 'Holy See' },
  { const: 'VC', title: 'Saint Vincent and the Grenadines' },
  { const: 'VE', title: 'Venezuela (Bolivarian Republic of)' },
  { const: 'VG', title: 'Virgin Islands (British)' },
  { const: 'VI', title: 'Virgin Islands (U.S.)' },
  { const: 'VN', title: 'Viet Nam' },
  { const: 'VU', title: 'Vanuatu' },
  { const: 'WF', title: 'Wallis and Futuna' },
  { const: 'WS', title: 'Samoa' },
  { const: 'YE', title: 'Yemen' },
  { const: 'YT', title: 'Mayotte' },
  { const: 'ZA', title: 'South Africa' },
  { const: 'ZM', title: 'Zambia' },
  { const: 'ZW', title: 'Zimbabwe' },
];

export const USPS_STATE_CODES = [
  { title: 'Alabama', const: 'AL' },
  { title: 'Alaska', const: 'AK' },
  { title: 'American Samoa', const: 'AS' },
  { title: 'Arizona', const: 'AZ' },
  { title: 'Arkansas', const: 'AR' },
  { title: 'California', const: 'CA' },
  { title: 'Colorado', const: 'CO' },
  { title: 'Connecticut', const: 'CT' },
  { title: 'Delaware', const: 'DE' },
  { title: 'District of Columbia', const: 'DC' },
  { title: 'Federated States of Micronesia', const: 'FM' },
  { title: 'Florida', const: 'FL' },
  { title: 'Georgia', const: 'GA' },
  { title: 'Guam', const: 'GU' },
  { title: 'Hawaii', const: 'HI' },
  { title: 'Idaho', const: 'ID' },
  { title: 'Illinois', const: 'IL' },
  { title: 'Indiana', const: 'IN' },
  { title: 'Iowa', const: 'IA' },
  { title: 'Kansas', const: 'KS' },
  { title: 'Kentucky', const: 'KY' },
  { title: 'Louisiana', const: 'LA' },
  { title: 'Maine', const: 'ME' },
  { title: 'Marshall Islands', const: 'MH' },
  { title: 'Maryland', const: 'MD' },
  { title: 'Massachusetts', const: 'MA' },
  { title: 'Michigan', const: 'MI' },
  { title: 'Minnesota', const: 'MN' },
  { title: 'Mississippi', const: 'MS' },
  { title: 'Missouri', const: 'MO' },
  { title: 'Montana', const: 'MT' },
  { title: 'Nebraska', const: 'NE' },
  { title: 'Nevada', const: 'NV' },
  { title: 'New Hampshire', const: 'NH' },
  { title: 'New Jersey', const: 'NJ' },
  { title: 'New Mexico', const: 'NM' },
  { title: 'New York', const: 'NY' },
  { title: 'North Carolina', const: 'NC' },
  { title: 'North Dakota', const: 'ND' },
  { title: 'Northern MarianaIs.', const: 'MP' },
  { title: 'Ohio', const: 'OH' },
  { title: 'Oklahoma', const: 'OK' },
  { title: 'Oregon', const: 'OR' },
  { title: 'Palau', const: 'PW' },
  { title: 'Pennsylvania', const: 'PA' },
  { title: 'Puerto Rico', const: 'PR' },
  { title: 'Rhode Island', const: 'RI' },
  { title: 'South Carolina', const: 'SC' },
  { title: 'South Dakota', const: 'SD' },
  { title: 'Tennessee', const: 'TN' },
  { title: 'Texas', const: 'TX' },
  { title: 'Utah', const: 'UT' },
  { title: 'Vermont', const: 'VT' },
  { title: 'Virginia', const: 'VA' },
  { title: 'Virgin Islands', const: 'VI' },
  { title: 'Washington', const: 'WA' },
  { title: 'West Virginia', const: 'WV' },
  { title: 'Wisconsin', const: 'WI' },
  { title: 'Wyoming', const: 'WY' },
];

export const CANADA_POST_PROVINCE_CODES = [
  { title: 'Alberta', const: 'AB' },
  { title: 'British Columbia', const: 'BC' },
  { title: 'Manitoba', const: 'MB' },
  { title: 'New Brunswick', const: 'NB' },
  { title: 'Newfoundland and Labrador', const: 'NL' },
  { title: 'Northwest Territories', const: 'NT' },
  { title: 'Nova Scotia', const: 'NS' },
  { title: 'Nunavut', const: 'NU' },
  { title: 'Ontario', const: 'ON' },
  { title: 'Prince Edward Island', const: 'PE' },
  { title: 'Quebec', const: 'QC' },
  { title: 'Saskatchewan', const: 'SK' },
  { title: 'Yukon', const: 'YT' },
];

export const ISO_3166_2_MX_STATE_CODES = [
  { title: 'Ciudad de México', const: 'CMX' },
  { const: 'AGU', title: 'Aguascalientes' },
  { const: 'BCN', title: 'Baja California' },
  { const: 'BCS', title: 'Baja California Sur' },
  { const: 'CAM', title: 'Campeche' },
  { const: 'COA', title: 'Coahuila de Zaragoza' },
  { const: 'COL', title: 'Colima' },
  { const: 'CHP', title: 'Chiapas' },
  { const: 'CHH', title: 'Chihuahua' },
  { const: 'DUR', title: 'Durango' },
  { const: 'GUA', title: 'Guanajuato' },
  { const: 'GRO', title: 'Guerrero' },
  { const: 'HID', title: 'Hidalgo' },
  { const: 'JAL', title: 'Jalisco' },
  { const: 'MEX', title: 'México' },
  { const: 'MIC', title: 'Michoacán de Ocampo' },
  { const: 'MOR', title: 'Morelos' },
  { const: 'NAY', title: 'Nayarit' },
  { const: 'NLE', title: 'Nuevo León' },
  { const: 'OAX', title: 'Oaxaca' },
  { const: 'PUE', title: 'Puebla' },
  { const: 'QUE', title: 'Querétaro' },
  { const: 'ROO', title: 'Quintana Roo' },
  { const: 'SLP', title: 'San Luis Potosí' },
  { const: 'SIN', title: 'Sinaloa' },
  { const: 'SON', title: 'Sonora' },
  { const: 'TAB', title: 'Tabasco' },
  { const: 'TAM', title: 'Tamaulipas' },
  { const: 'TLA', title: 'Tlaxcala' },
  { const: 'VER', title: 'Veracruz de Ignacio de la Llave' },
  { const: 'YUC', title: 'Yucatán' },
  { const: 'ZAC', title: 'Zacatecas' },
];

const PartyIdentificationTypeCode = {
  TAXPAYER_IDENTIFICATION_NUMBER: {
    const: 4,
    title: 'Taxpayer Identification Number (TIN) ',
  },
  TRANSMITTER_CONTROL_CODE: {
    const: 28,
    title: 'Transmitter Control Code (TCC)',
  },
  EMPLOYER_IDENTIFICATION_NUMBER: {
    const: 2,
    title: 'Employer Identification Number (EIN)',
  },
  SOCIAL_SECURITY_NUMBER_OR_INDIVIDUAL_TAXPAYER_ID_NUMBER: {
    const: 1,
    title: 'Social Security Number (SSN)/Individual Taxpayer Identification Number (ITIN)',
  },
  FOREIGN_TAXPAYER_IDENTIFICATION_NUMBER: {
    const: 9,
    title: 'Foreign Taxpayer Identification Number (TIN)',
  },
  CENTRAL_REGISTRATION_DEPOSITORY_NUMBER: {
    const: 10,
    title: 'Central Registration Depository (CRD) number',
  },
  INVESTMENT_ADVISER_REGISTRATION_NUMBER: {
    const: 11,
    title: 'Investment Adviser Registration (IARD) number',
  },
  NATIONAL_FUTURES_ASSOCIATION_NUMBER: {
    const: 12,
    title: 'National Futures Association (NFA ID) number',
  },
  RESEARCH_STATISTICS_SUPERVISION_AND_DISCOUNT_NUMBER: {
    const: 14,
    title: 'Research, Statistics, Supervision, and Discount (RSSD) number',
  },
  SECURITIES_AND_EXCHANGE_COMMISSION_NUMBER: {
    const: 13,
    title: 'Securities and Exchange Commission (SEC) number',
  },
  NATIONAL_ASSOCIATION_OF_INSURANCE_COMMISSIONERS_NUMBER: {
    const: 32,
    title: 'National Association of Insurance Commissioners (NAIC) number',
  },
  NATIONAL_MORTGAGE_LICENSING_SYSTEM_NUMBER: {
    const: 33,
    title: 'National Mortgage Licensing System (NMLS) number',
  },
  INTERNAL_CONTROL_FILE_NUMBER: {
    const: 29,
    title: 'Internal control/file number',
  },
  DRIVER_LICENSE_STATE_ID: {
    const: 5,
    title: "Driver's license/State ID",
  },
  PASSPORT: {
    const: 6,
    title: 'Passport',
  },
  ALIEN_REGISTRATION: {
    const: 7,
    title: 'Alien registration',
  },
  OTHER_IDENTIFICATION: {
    const: 999,
    title: 'Other Identification',
  },
};

export const FillingInstitutionTinIdentificationTypeCode = [
  PartyIdentificationTypeCode.EMPLOYER_IDENTIFICATION_NUMBER,
  PartyIdentificationTypeCode.SOCIAL_SECURITY_NUMBER_OR_INDIVIDUAL_TAXPAYER_ID_NUMBER,
  PartyIdentificationTypeCode.FOREIGN_TAXPAYER_IDENTIFICATION_NUMBER,
];
export const FilingInstitutionNonTinIdentificationTypeCode = [
  PartyIdentificationTypeCode.CENTRAL_REGISTRATION_DEPOSITORY_NUMBER,
  PartyIdentificationTypeCode.INVESTMENT_ADVISER_REGISTRATION_NUMBER,
  PartyIdentificationTypeCode.NATIONAL_FUTURES_ASSOCIATION_NUMBER,
  PartyIdentificationTypeCode.RESEARCH_STATISTICS_SUPERVISION_AND_DISCOUNT_NUMBER,
  PartyIdentificationTypeCode.SECURITIES_AND_EXCHANGE_COMMISSION_NUMBER,
  PartyIdentificationTypeCode.NATIONAL_ASSOCIATION_OF_INSURANCE_COMMISSIONERS_NUMBER,
  PartyIdentificationTypeCode.NATIONAL_MORTGAGE_LICENSING_SYSTEM_NUMBER,
];

export const OrganizationSubtypeID = {
  CLEARING_BROKER_SECURITIES: { const: 535, title: 'Clearing broker-securities' },
  CPO_CTA: { const: 534, title: 'CPO/CTA' },
  EXECUTION_ONLY_BROKER_SECURITIES: { const: 541, title: 'Execution-only broker securities' },
  FUTURES_COMMISSION_MERCHANT: { const: 508, title: 'Futures Commission Merchant' },
  HOLDING_COMPANY: { const: 504, title: 'Holding Company' },
  INTRODUCING_BROKER_COMMODITY: { const: 513, title: 'Introducing broker-commodity' },
  INTRODUCING_BROKER_SECURITIES: { const: 540, title: 'Introducing broker-securities' },
  INVESTMENT_ADVISER: { const: 514, title: 'Investment adviser' },
  INVESTMENT_COMPANY: { const: 539, title: 'Investment company' },
  RETAIL_FOREIGN_EXCHANGE_DEALER: { const: 533, title: 'Retail foreign exchange dealer' },
  SELF_CLEARING_BROKER_SECURITIES: { const: 542, title: 'Self-clearing broker-securities' },
  SRO_FUTURES: { const: 528, title: 'SRO futures' },
  SRO_SECURITIES: { const: 529, title: 'SRO securities' },
  SUBSIDIARY_OF_FINANCIAL_BANK_HOLDING_COMPANY: {
    const: 503,
    title: 'Subsidiary of financial/bank holding company',
  },
  OTHER: { const: 5999, title: 'Other' },
};
// NOTE: please refer to https://bsaefiling.fincen.treas.gov/NAICSCodeList.html for authorized NAICS code.
export const NAICSCode = [
  { const: 721, title: 'Accommodation' },
  { const: 722, title: 'Food Services and Drinking Places' },
  { const: 561, title: 'Administrative and Support Services' },
  { const: 562, title: 'Waste Management and Remediation Services' },
  { const: 112, title: 'Animal Production' },
  { const: 111, title: 'Crop Production' },
  { const: 114, title: 'Fishing, Hunting and Trapping' },
  { const: 113, title: 'Forestry and Logging' },
  { const: 115, title: 'Support Activities for Agriculture and Forestry' },
  { const: 7131, title: 'Amusement Parks and Arcades' },
  { const: 713, title: 'Amusement, Gambling, and Recreation Industries' },
  { const: 7132, title: 'Gambling Industries' },
  { const: 712, title: 'Museums, Historical Sites, and Similar Institutions' },
  { const: 7139, title: 'Other Amusement and Recreation Industries' },
  { const: 711, title: 'Performing Arts, Spectator Sports, and Related Industries' },
  { const: 236, title: 'Construction of Buildings' },
  { const: 237, title: 'Heavy and Civil Engineering Construction' },
  { const: 238, title: 'Specialty Trade Contractors' },
  { const: 611, title: 'Educational Services' },
  { const: 5223, title: 'Activities Related to Credit Intermediation' },
  { const: 5242, title: 'Agencies, Brokerages, and Other Insurance Related Activities' },
  { const: 522, title: 'Credit Intermediation and Related Activities' },
  { const: 5221, title: 'Depository Credit Intermediation' },
  { const: 525, title: 'Funds, Trusts, and Other Financial Vehicles' },
  { const: 5251, title: 'Insurance and Employee Benefit Funds' },
  { const: 5241, title: 'Insurance Carriers' },
  { const: 524, title: 'Insurance Carriers and Related Activities' },
  { const: 521, title: 'Monetary Authorities-Central Bank' },
  { const: 52231, title: 'Mortgage and nonmortgage loan brokers*' },
  { const: 5239, title: 'Other Financial Investment Activities' },
  { const: 5259, title: 'Other Investment Pools and Funds' },
  { const: 5231, title: 'Securities and Commodity Contracts Intermediation and  Brokerage' },
  { const: 5232, title: 'Securities and Commodity Exchanges' },
  {
    const: 523,
    title:
      'Securities, Commodity Contracts, and Other Financial Investments and Related Activities',
  },
  { const: 621, title: 'Ambulatory Health Care Services' },
  { const: 6233, title: 'Community Care Facilities for the Elderly' },
  { const: 6221, title: 'General Medical and Surgical Hospitals' },
  { const: 6216, title: 'Home Health Care Services' },
  { const: 622, title: 'Hospitals' },
  { const: 6215, title: 'Medical and Diagnostic Laboratories' },
  { const: 623, title: 'Nursing and Residential Care Facilities' },
  { const: 6231, title: 'Nursing Care Facilities' },
  { const: 6212, title: 'Offices of Dentists' },
  { const: 6213, title: 'Offices of Other Health Practitioners' },
  { const: 6211, title: 'Offices of Physicians' },
  { const: 6219, title: 'Other Ambulatory Health Care Services' },
  { const: 6239, title: 'Other Residential Care Facilities' },
  { const: 6214, title: 'Outpatient Care Centers' },
  { const: 6222, title: 'Psychiatric and Substance Abuse Hospitals' },
  {
    const: 6232,
    title: 'Residential Mental Retardation, Mental Health and Substance Abuse Facilities',
  },
  { const: 624, title: 'Social Assistance' },
  { const: 6223, title: 'Specialty (except Psychiatric and Substance Abuse) Hospitals' },
  { const: 515, title: 'Broadcasting (except Internet)' },
  { const: 518, title: 'Data Processing, Hosting and Related Services' },
  { const: 512, title: 'Motion Picture and Sound Recording Industries' },
  { const: 519, title: 'Other Information Services' },
  { const: 5179, title: 'Other Telecommunications' },
  { const: 511, title: 'Publishing Industries (except Internet)' },
  { const: 5174, title: 'Satellite Telecommunications' },
  { const: 517, title: 'Telecommunications' },
  { const: 5171, title: 'Wired Telecommunications Carriers' },
  { const: 5172, title: 'Wireless Telecommunications Carriers (except Satellite)' },
  { const: 551, title: 'Management of Companies and Enterprises' },
  { const: 315, title: 'Apparel Manufacturing' },
  { const: 312, title: 'Beverage and Tobacco Product Manufacturing' },
  { const: 325, title: 'Chemical Manufacturing' },
  { const: 334, title: 'Computer and Electronic Product Manufacturing' },
  { const: 335, title: 'Electrical Equipment, Appliance, and Component Manufacturing' },
  { const: 332, title: 'Fabricated Metal Product Manufacturing' },
  { const: 311, title: 'Food Manufacturing' },
  { const: 337, title: 'Furniture and Related Product Manufacturing' },
  { const: 316, title: 'Leather and Allied Product Manufacturing' },
  { const: 333, title: 'Machinery Manufacturing' },
  { const: 339, title: 'Miscellaneous Manufacturing' },
  { const: 327, title: 'Nonmetallic Mineral Product Manufacturing' },
  { const: 322, title: 'Paper Manufacturing' },
  { const: 324, title: 'Petroleum and Coal Products Manufacturing' },
  { const: 326, title: 'Plastics and Rubber Products Manufacturing' },
  { const: 331, title: 'Primary Metal Manufacturing' },
  { const: 323, title: 'Printing and Related Support Activities' },
  { const: 313, title: 'Textile Mills' },
  { const: 314, title: 'Textile Product Mills' },
  { const: 336, title: 'Transportation Equipment Manufacturing' },
  { const: 321, title: 'Wood Product Manufacturing' },
  { const: 212, title: 'Mining (except Oil and Gas)' },
  { const: 211, title: 'Oil and Gas Extraction' },
  { const: 213, title: 'Support Activities for Mining' },
  { const: 5412, title: 'Accounting, Tax Preparation, Bookkeeping, and Payroll Services' },
  { const: 5418, title: 'Advertising, Public Relations, and Related Services' },
  { const: 5413, title: 'Architectural, Engineering, and Related Services' },
  { const: 5415, title: 'Computer Systems Design and Related Services' },
  { const: 5411, title: 'Legal Services' },
  { const: 5416, title: 'Management, Scientific, and Technical Consulting Services' },
  { const: 5419, title: 'Other Professional, Scientific, and Technical Services' },
  { const: 541, title: 'Professional, Scientific, and Technical Services' },
  { const: 5417, title: 'Scientific Research and Development Services' },
  { const: 5414, title: 'Specialized Design Services' },
  { const: 926, title: 'Administration of Economic Programs' },
  { const: 924, title: 'Administration of Environmental Quality Programs' },
  {
    const: 925,
    title: 'Administration of Housing Programs, Urban Planning, and Community Development',
  },
  { const: 923, title: 'Administration of Human Resource Programs' },
  { const: 921, title: 'Executive, Legislative, and Other General Government Support' },
  { const: 922, title: 'Justice, Public Order, and Safety Activities' },
  { const: 928, title: 'National Security and International Affairs' },
  { const: 927, title: 'Space Research and Technology' },
  { const: 5313, title: 'Activities Related to Real Estate' },
  { const: 5321, title: 'Automotive Equipment Rental and Leasing' },
  { const: 5324, title: 'Commercial and Industrial Machinery and Equipment Rental and Leasing' },
  { const: 5322, title: 'Consumer Goods Rental' },
  { const: 5323, title: 'General Rental Centers' },
  { const: 533, title: 'Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)' },
  { const: 5311, title: 'Lessors of Real Estate' },
  { const: 5312, title: 'Offices of Real Estate Agents and Brokers' },
  { const: 531, title: 'Real Estate' },
  { const: 532, title: 'Rental and Leasing Services' },
  { const: 4411, title: 'Automobile Dealers' },
  { const: 4413, title: 'Automotive Parts, Accessories, and Tire Stores' },
  { const: 444, title: 'Building Material and Garden Equipment and Supplies Dealers' },
  { const: 448, title: 'Clothing and Clothing Accessories Stores' },
  { const: 4481, title: 'Clothing Stores' },
  { const: 4543, title: 'Direct Selling Establishments' },
  { const: 4541, title: 'Electronic Shopping and Mail-Order Houses' },
  { const: 443, title: 'Electronics and Appliance Stores' },
  { const: 445, title: 'Food and Beverage Stores' },
  { const: 442, title: 'Furniture and Home Furnishings Stores' },
  { const: 447, title: 'Gasoline Stations' },
  { const: 452, title: 'General Merchandise Stores' },
  { const: 446, title: 'Health and Personal Care Stores' },
  { const: 4483, title: 'Jewelry, Luggage, and Leather Goods Stores' },
  { const: 453, title: 'Miscellaneous Store Retailers' },
  { const: 441, title: 'Motor Vehicle and Parts Dealers' },
  { const: 454, title: 'Nonstore Retailers' },
  { const: 4412, title: 'Other Motor Vehicle Dealers' },
  { const: 4482, title: 'Shoe Stores' },
  { const: 451, title: 'Sporting Goods, Hobby, Book, and Music Stores' },
  { const: 4542, title: 'Vending Machine Operators' },
  { const: 481, title: 'Air Transportation' },
  { const: 4921, title: 'Couriers and Express Delivery Services' },
  { const: 492, title: 'Couriers and Messengers' },
  { const: 4922, title: 'Local Messengers and Local Delivery' },
  { const: 4869, title: 'Other Pipeline Transportation' },
  { const: 486, title: 'Pipeline Transportation' },
  { const: 4861, title: 'Pipeline Transportation of Crude Oil' },
  { const: 4862, title: 'Pipeline Transportation of Natural Gas' },
  { const: 491, title: 'Postal Service' },
  { const: 482, title: 'Rail Transportation' },
  { const: 487, title: 'Scenic and Sightseeing Transportation' },
  { const: 488, title: 'Support Activities for Transportation' },
  { const: 485, title: 'Transit and Ground Passenger Transportation' },
  { const: 484, title: 'Truck Transportation' },
  { const: 493, title: 'Warehousing and Storage' },
  { const: 483, title: 'Water Transportation' },
  { const: 221, title: 'Utilities' },
  { const: 4243, title: 'Apparel, Piece Goods, and Notions Merchant Wholesalers' },
  { const: 4248, title: 'Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers' },
  { const: 4246, title: 'Chemical and Allied Products Merchant Wholesalers' },
  { const: 4242, title: "Drugs and Druggists' Sundries Merchant Wholesalers" },
  { const: 4236, title: 'Electrical and Electronic Goods Merchant Wholesalers' },
  { const: 4245, title: 'Farm Product Raw Material Merchant Wholesalers' },
  { const: 4232, title: 'Furniture and Home Furnishing Merchant Wholesalers' },
  { const: 4244, title: 'Grocery and Related Product Merchant Wholesalers' },
  {
    const: 4237,
    title: 'Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers',
  },
  { const: 4233, title: 'Lumber and Other Construction Materials Merchant Wholesalers' },
  { const: 4238, title: 'Machinery, Equipment, and Supplies Merchant Wholesalers' },
  { const: 423, title: 'Merchant Wholesalers, Durable Goods' },
  { const: 424, title: 'Merchant Wholesalers, Nondurable Goods' },
  { const: 4235, title: 'Metal and Mineral (except Petroleum) Merchant Wholesalers' },
  { const: 4239, title: 'Miscellaneous Durable Goods Merchant Wholesalers' },
  { const: 4249, title: 'Miscellaneous Nondurable Goods Merchant Wholesalers' },
  { const: 4231, title: 'Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers' },
  { const: 4241, title: 'Paper and Paper Product Merchant Wholesalers' },
  { const: 4247, title: 'Petroleum and Petroleum Products Merchant Wholesalers' },
  { const: 4234, title: 'Professional and Commercial Equipment and Supplies Merchant Wholesalers' },
  { const: 425, title: 'Wholesale Electronic Markets and Agents and Brokers' },
  { const: 8139, title: 'Business, Professional, Labor, Political, and Similar Organizations' },
  { const: 8134, title: 'Civic and Social Organizations' },
  { const: 8132, title: 'Grantmaking and Giving Services' },
  { const: 812, title: 'Personal and Laundry Services' },
  { const: 814, title: 'Private Households' },
  { const: 8131, title: 'Religious Organizations' },
  { const: 813, title: 'Religious, Grantmaking, Civic, Professional, and Similar Organizations' },
  { const: 811, title: 'Repair and Maintenance' },
  { const: 8133, title: 'Social Advocacy Organizations' },
];

export const FilingInstitutionOrganizationSubtypeCodes = [
  OrganizationSubtypeID.CLEARING_BROKER_SECURITIES,
  OrganizationSubtypeID.CPO_CTA,
  OrganizationSubtypeID.EXECUTION_ONLY_BROKER_SECURITIES,
  OrganizationSubtypeID.FUTURES_COMMISSION_MERCHANT,
  OrganizationSubtypeID.HOLDING_COMPANY,
  OrganizationSubtypeID.INTRODUCING_BROKER_COMMODITY,
  OrganizationSubtypeID.INTRODUCING_BROKER_SECURITIES,
  OrganizationSubtypeID.INVESTMENT_ADVISER,
  OrganizationSubtypeID.INVESTMENT_COMPANY,
  OrganizationSubtypeID.RETAIL_FOREIGN_EXCHANGE_DEALER,
  OrganizationSubtypeID.SELF_CLEARING_BROKER_SECURITIES,
  OrganizationSubtypeID.SRO_FUTURES,
  OrganizationSubtypeID.SRO_SECURITIES,
  OrganizationSubtypeID.SUBSIDIARY_OF_FINANCIAL_BANK_HOLDING_COMPANY,
  OrganizationSubtypeID.OTHER,
];

export const REQUIRED_MAILING_ADDRESS: JSONSchema7 = {
  type: 'object',
  properties: {
    rawStreetAddress1Text: {
      title: 'Address',
      type: 'string',
      maxLength: 100,
      pattern: '^(?!\\s).*(?<!\\s)$',
    },
    rawCityText: {
      title: 'City',
      type: 'string',
      maxLength: 50,
      pattern: '^(?!\\s).*(?<!\\s)$',
    },
    rawCountryCodeText: {
      title: 'Country',
      type: 'string',
      oneOf: ISO_3166_COUNTRY_CODES,
    },
  },
  required: ['rawStreetAddress1Text', 'rawCityText', 'rawCountryCodeText'],
  allOf: [
    {
      if: {
        $comment:
          'United States state/territory codes must adhere to the two-letter codes used by the United States Postal Service when the country is equal to US or a U.S. Territory. If a U.S. Territory is recorded for the country, it must also be recorded for the state.',
        properties: {
          rawCountryCodeText: { const: 'US' },
        },
        required: ['rawCountryCodeText'],
      },
      then: {
        properties: {
          rawUSStateCodeText: {
            title: 'State',
            type: 'string',
            oneOf: USPS_STATE_CODES,
          },
          rawZIPCode: {
            title: 'ZIP Code',
            type: 'string',
            pattern: '^[0-9]{5}([0-9]{4})?$',
          },
        },
        required: ['rawUSStateCodeText', 'rawZIPCode'],
      },
    },
    {
      if: {
        $comment:
          'Canadian province/territory codes must adhere to the two-letter codes used by the Canadian Post Corporation when the country is equal to CA.',
        properties: {
          rawCountryCodeText: { const: 'CA' },
        },
        required: ['rawCountryCodeText'],
      },
      then: {
        properties: {
          rawCAStateCodeText: {
            title: 'Province',
            type: 'string',
            oneOf: CANADA_POST_PROVINCE_CODES,
          },
          rawZIPCode: {
            title: 'Postal Code',
            type: 'string',
            pattern: '^[A-Z][0-9][A-Z][0-9][A-Z][0-9]$',
          },
        },
        required: ['rawCAStateCodeText', 'rawZIPCode'],
      },
    },
    {
      if: {
        $comment:
          'Mexican state/federal district codes must adhere to the standards of ISO 3166-2:MX when the country is equal to MX.',
        properties: {
          rawCountryCodeText: { const: 'MX' },
        },
        required: ['rawCountryCodeText'],
      },
      then: {
        properties: {
          rawMXStateCodeText: {
            title: 'State',
            type: 'string',
            oneOf: ISO_3166_2_MX_STATE_CODES,
          },
          rawZIPCode: {
            title: 'ZIP Code',
            type: 'string',
            pattern: '^[0-9]{5}([0-9]{4})?$',
          },
        },
        required: ['rawMXStateCodeText', 'rawZIPCode'],
      },
    },
    {
      if: {
        properties: {
          rawCountryCodeText: {
            not: { anyOf: [{ const: 'US' }, { const: 'CA' }, { const: 'MX' }] },
          },
        },
      },
      then: {
        properties: {
          rawZIPCode: {
            title: 'ZIP/Postal Code',
            type: 'string',
            pattern: '^[A-Z0-9]*$',
          },
        },
        required: ['rawZIPCode'],
      },
    },
  ],
};

export const MAILING_ADDRESS: JSONSchema7 = {
  type: 'object',
  properties: {
    rawStreetAddress1Text: {
      title: 'Address',
      type: 'string',
      maxLength: 100,
      pattern: '^(?!\\s).*(?<!\\s)$',
    },
    rawCityText: {
      title: 'City',
      type: 'string',
      maxLength: 50,
      pattern: '^(?!\\s).*(?<!\\s)$',
    },
    rawCountryCodeText: {
      title: 'Country',
      type: 'string',
      oneOf: ISO_3166_COUNTRY_CODES,
    },
  },
  allOf: [
    {
      if: {
        $comment:
          'United States state/territory codes must adhere to the two-letter codes used by the United States Postal Service when the country is equal to US or a U.S. Territory. If a U.S. Territory is recorded for the country, it must also be recorded for the state.',
        properties: {
          rawCountryCodeText: { const: 'US' },
        },
        required: ['rawCountryCodeText'],
      },
      then: {
        properties: {
          rawUSStateCodeText: {
            title: 'State',
            type: 'string',
            oneOf: USPS_STATE_CODES,
          },
          rawZIPCode: {
            title: 'ZIP Code',
            type: 'string',
            pattern: '^[0-9]{5}([0-9]{4})?$',
          },
        },
      },
    },
    {
      if: {
        $comment:
          'Canadian province/territory codes must adhere to the two-letter codes used by the Canadian Post Corporation when the country is equal to CA.',
        properties: {
          rawCountryCodeText: { const: 'CA' },
        },
        required: ['rawCountryCodeText'],
      },
      then: {
        properties: {
          rawCAStateCodeText: {
            title: 'Province',
            type: 'string',
            oneOf: CANADA_POST_PROVINCE_CODES,
          },
          rawZIPCode: {
            title: 'Postal Code',
            type: 'string',
            pattern: '^[A-Z][0-9][A-Z][0-9][A-Z][0-9]$',
          },
        },
      },
    },
    {
      if: {
        $comment:
          'Mexican state/federal district codes must adhere to the standards of ISO 3166-2:MX when the country is equal to MX.',
        properties: {
          rawCountryCodeText: { const: 'MX' },
        },
        required: ['rawCountryCodeText'],
      },
      then: {
        properties: {
          rawMXStateCodeText: {
            title: 'State',
            type: 'string',
            oneOf: ISO_3166_2_MX_STATE_CODES,
          },
          rawZIPCode: {
            title: 'ZIP Code',
            type: 'string',
            pattern: '^[0-9]{5}([0-9]{4})?$',
          },
        },
        required: ['rawMXStateCodeText'],
      },
    },
    {
      if: {
        properties: {
          rawCountryCodeText: {
            not: { anyOf: [{ const: 'US' }, { const: 'CA' }, { const: 'MX' }] },
          },
        },
      },
      then: {
        properties: {
          rawZIPCode: {
            title: 'ZIP/Postal Code',
            type: 'string',
            pattern: '^[A-Z0-9]*$',
          },
        },
      },
    },
  ],
};

export const TIN: JSONSchema7 = {
  type: 'object',
  properties: {
    partyIdentificationTypeCode: {
      title: 'TIN Type',
      type: 'number',
      oneOf: FillingInstitutionTinIdentificationTypeCode,
    },
  },
  // required: ['partyIdentificationTypeCode'],
  allOf: [
    {
      if: {
        properties: {
          partyIdentificationTypeCode: { oneOf: [{ const: 1 }, { const: 2 }] },
        },
        required: ['partyIdentificationTypeCode'],
      },
      then: {
        properties: {
          partyIdentificationNumber: {
            title: 'TIN',
            type: 'string',
            minLength: 9,
            maxLength: 9,
            pattern: '^[0-9]*$',
          },
        },
        // required: ['partyIdentificationNumber'],
      },
    },
    {
      if: {
        properties: {
          partyIdentificationTypeCode: { oneOf: [{ const: 9 }] },
        },
        required: ['partyIdentificationTypeCode'],
      },
      then: {
        properties: {
          partyIdentificationNumber: {
            title: 'TIN',
            type: 'string',
            maxLength: 25,
            pattern: '^[A-Za-z0-9]*$',
          },
        },
        // required: ['partyIdentificationNumber'],
      },
    },
  ],
};
